import type { UseLoginUserReturnType } from "@/hooks/auth/loginUser/types";
import { useRedirectUserToSignIn } from "@/hooks/session/useRedirectUserToSignIn/hook";

const useLoginUser = (): UseLoginUserReturnType => {
  const { redirectUserToSignIn } = useRedirectUserToSignIn();
  const loginUser: UseLoginUserReturnType["loginUser"] = async (args) => {
    await redirectUserToSignIn(args);
  };

  return { loginUser };
};

export { useLoginUser };
